(function () {
  if (window.__mubligCartSyncLoaded) return;
  window.__mubligCartSyncLoaded = true;

  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?/;

  function isCartMutation(input, init) {
    var url = '';
    var method = 'GET';

    if (typeof input === 'string') {
      url = input;
    } else if (input && input.url) {
      url = input.url;
    }

    if (init && init.method) {
      method = init.method;
    } else if (input && input.method) {
      method = input.method;
    }

    url = String(url || '');
    method = String(method || 'GET').toUpperCase();

    return CART_MUTATION_RE.test(url) && method !== 'GET';
  }

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;

    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  }

  function setText(selector, value) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.textContent = value;
      el.removeAttribute('hidden');
      el.classList.remove('hidden');
      el.classList.remove('is-empty');
    });
  }

  function updateCartBubbles(cart) {
    var count = String(cart.item_count || 0);

    setText('[data-cart-count]', count);
    setText('[data-header-cart-count]', count);
    setText('[data-mublig-cart-count]', count);
    setText('.cart-count-bubble span', count);
    setText('.cart-count-bubble .visually-hidden + span', count);

    document.querySelectorAll('.cart-count-bubble, [data-cart-count-bubble]').forEach(function (bubble) {
      if (cart.item_count > 0) {
        bubble.removeAttribute('hidden');
        bubble.classList.remove('hidden');
        bubble.classList.remove('is-empty');
      } else {
        bubble.setAttribute('hidden', 'hidden');
        bubble.classList.add('hidden');
        bubble.classList.add('is-empty');
      }
    });
  }

  function updateCartTotals(cart) {
    var total = formatMoney(cart.total_price || 0);

    setText('[data-cart-total]', total);
    setText('[data-header-cart-total]', total);
    setText('[data-mublig-cart-total]', total);
  }

  function dispatchCartEvents(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cart }
    }));

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { cart: cart }
    }));

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cart }
    }));

    window.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: cart }
    }));
  }

  function refreshCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (!cart) return;

        updateCartBubbles(cart);
        updateCartTotals(cart);
        dispatchCartEvents(cart);
      })
      .catch(function () {});
  }

  window.MubligRefreshCart = refreshCart;

  /**
   * Fetch-AJAX abfangen
   */
  if (window.fetch) {
    var originalFetch = window.fetch;

    window.fetch = function () {
      var input = arguments[0];
      var init = arguments[1];

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartMutation(input, init)) {
          window.setTimeout(refreshCart, 250);
          window.setTimeout(refreshCart, 900);
        }

        return response;
      });
    };
  }

  /**
   * XMLHttpRequest-AJAX abfangen
   */
  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__mubligIsCartMutation = CART_MUTATION_RE.test(String(url || '')) && String(method || 'GET').toUpperCase() !== 'GET';
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__mubligIsCartMutation) {
        this.addEventListener('loadend', function () {
          window.setTimeout(refreshCart, 250);
          window.setTimeout(refreshCart, 900);
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  /**
   * Normale Produktformulare absichern
   */
  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    window.setTimeout(refreshCart, 700);
    window.setTimeout(refreshCart, 1400);
  }, true);

  /**
   * Nach Seitenwechsel einmal initial synchronisieren
   */
  document.addEventListener('DOMContentLoaded', function () {
    window.setTimeout(refreshCart, 300);
  });
})();